import React from 'react';
import DOMPurify from 'dompurify';

const ListItem = ({styleName, data}) => {
    const {name, description} = data;
    return (
        <div className={`user-list d-flex flex-row  ${styleName}`}>
            <div className="description">
                <h3>{name}</h3>
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }} />
            </div>
        </div>
    );
};

export default ListItem;


// WEBPACK FOOTER //
// ./components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/ListItem.js